/**
 * Returns a safe http(s) URL for links and window.open, or null if the value
 * cannot be parsed (e.g. bare "http:" from bad imports).
 */
export function normalizeWebsiteForHref(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  // Common malformed values that still "look" truthy in the UI
  if (/^https?:$/i.test(trimmed)) return null;

  let candidate = trimmed;
  if (/^\/\//.test(candidate)) {
    candidate = `https:${candidate}`;
  } else if (!/^https?:\/\//i.test(candidate)) {
    candidate = `https://${candidate}`;
  }

  try {
    const u = new URL(candidate);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
    if (!u.hostname) return null;
    return u.href;
  } catch {
    return null;
  }
}
